import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';


import { BaseService } from './base.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(public injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let _baseService = this.injector.get(BaseService);


    const reqest_input = req.clone(
      {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Auth-Key': 'sugu',
            'Client-Security-Token': `${_baseService.getToken()}`,
          }
        )
      }
    );


    return next.handle(reqest_input);
  }

}
